import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import KuotaForm from './components/KuotaForm';
import PreviewSection from './components/PreviewSection';
import AuthorCard from './components/AuthorCard';
import SocialLinks from './components/SocialLinks';
import LoadingOverlay from './components/LoadingOverlay';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'toastr/build/toastr.min.css';

function App() {
  const [isLoading, setIsLoading] = useState(false);

  // Fungsi untuk handle loading dari child component
  const handleLoadingChange = (loadingState) => {
    setIsLoading(loadingState);
  };

  return (
    <div className="App">
      <LoadingOverlay isLoading={isLoading} />
      <div className="container atur1">
        <Header />
        <div className="alert alert-success" style={{ textAlign: 'justify' }}>
          <strong><i className="fa fa-bullhorn" aria-hidden="true"></i> INFO</strong><br />
          Mohon jangan melakukan SPAM. Gunakan fitur ini dengan bijak!
        </div>
        
        {/* Kirim fungsi handleLoadingChange ke KuotaForm */}
        <KuotaForm onLoadingChange={handleLoadingChange} />
        
        <PreviewSection />
        <AuthorCard />
        <SocialLinks />
        <div className="thank-you">
          <i className="fas fa-heart" style={{ color: '#f72585' }}></i> Terima kasih telah menggunakan layanan ini
        </div>
      </div>
    </div>
  );
}

export default App;
